import { PROP_TYPES, propValidator } from '@/utils/validators'
import { generateServerCacheKey } from '@/plugins/helper'

export const serverCacheKey = {
  serverCacheKey: ({ lastModified }) => generateServerCacheKey(lastModified),
  props: {
    lastModified: propValidator([PROP_TYPES.NUMBER, PROP_TYPES.STRING], false)
  }
}
